var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsKeyboardArrowDownRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.02495C12.1333 9.02495 12.2626 9.04995 12.388 9.09995C12.5133 9.14995 12.6173 9.21662 12.7 9.29995L17.3 13.9C17.4833 14.0833 17.575 14.3166 17.575 14.6C17.575 14.8833 17.4833 15.1166 17.3 15.3C17.1166 15.4833 16.8833 15.575 16.6 15.575C16.3166 15.575 16.0833 15.4833 15.9 15.3L12 11.4L8.09995 15.3C7.91662 15.4833 7.68328 15.575 7.39995 15.575C7.11662 15.575 6.88329 15.4833 6.69995 15.3C6.51662 15.1166 6.42495 14.8833 6.42495 14.6C6.42495 14.3166 6.51662 14.0833 6.69995 13.9L11.3 9.29995C11.4 9.19995 11.5083 9.12895 11.625 9.08695C11.7416 9.04495 11.8666 9.02428 12 9.02495Z",
    fill: "#E9FE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsKeyboardArrowDownRounded);
export default __webpack_public_path__ + "static/media/material-symbols_keyboard-arrow-down-rounded.5c70a0c7a15f66d3ee543462315f7138.svg";
export { ForwardRef as ReactComponent };